/* eslint import/no-named-default: off */

import { default as fetchSportsTree } from './fetch_sports_tree';

export default {
  fetchSportsTree,
};
